export default "__VITE_ASSET__e45839ca__"